class MainHeader extends HTMLElement {
      constructor() {
        super();
        this.currentScrollTop = 0;
        if(this.classList.contains('on_scroll_up')){
          window.addEventListener('scroll', this.onScroll.bind(this), false);
        }
  
        window.addEventListener('scroll', this.announcementHeightCal.bind(this), false);
        window.addEventListener('scroll', this.transparentHeader.bind(this), false);
        this.addEventListener('mouseover', this.transparentHeaderAdd.bind(this), false);
        this.addEventListener('mouseout', this.transparentHeaderRemove.bind(this), false);
      }
      
      
      onScroll() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        this.headerHeight = this?.getBoundingClientRect().height.toFixed(2) || 0;
        if (scrollTop > 100) {
          if (scrollTop > this.currentScrollTop) {
            this.classList.add('header-sticky-hide');
            document.body.style.setProperty('--header-height', `0px`);
          } else {
            this.classList.remove('header-sticky-hide');
            document.body.style.setProperty('--header-height', `${this.headerHeight}px`); 
          }
        } else {
          this.classList.remove('header-sticky-hide');
          document.body.style.setProperty('--header-height', `${this.headerHeight}px`);
        }
        
        this.currentScrollTop = scrollTop;
      }
       announcementHeightCal(){
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          document.body.style.setProperty('--announcement-height', `${Math.max((this.announcementHeight - scrollTop),0)}px`);
          
        }
       headerHeightupdate() {
          this.announcementHeight = document.querySelector('.announcement-bar')?.getBoundingClientRect().height.toFixed(2) || 0;
          this.headerHeight = this.getBoundingClientRect().height.toFixed(2) || 0;
          document.body.style.setProperty('--announcement-height', `${this.announcementHeight}px`);
          document.body.style.setProperty('--header-height', `${this.headerHeight}px`);
      }
       transparentHeader() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          if(this.classList.contains('transparent')){
            if (scrollTop > 110) {
                this.classList.add('background-header-color')
            } else {
                this.classList.remove('background-header-color')
            }
          }
          
          this.currentScrollTop = scrollTop;
        }
        transparentHeaderAdd(){        
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
           if (scrollTop <= 110 && this.classList.contains('transparent') && !this.classList.contains('background-header-color')) {
              this.classList.add('background-header-color')
           }
        }
        transparentHeaderRemove(){        
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
           if (scrollTop <= 110 && this.classList.contains('transparent') && this.classList.contains('background-header-color')) {
              this.classList.remove('background-header-color')
           }
        }
  
    }

customElements.define('main-header', MainHeader);
class HeaderDrawerMenu extends HTMLElement {
  constructor() {
    super();
    this.headerSection = this.closest('.main-header-section');
    this.headerWrapper = this.headerSection?.querySelector('.main-header--wrapper') || null;
    this.closeBtns = this.querySelectorAll('[data-close-drawer]');
    this.drawerBtns = this.headerSection?.querySelectorAll('[data-drawer-head]') || [];
    this.lastFocusedElement =""
    this.closeTimer = null;
    this.focusTimer = null;
    this.animationUnlockTimer = null;
    this.isAnimating = false;
    this.controlsLockTop = null;
    this.handleResize = this.handleResize.bind(this);
    this.handleBackdropClick = this.handleBackdropClick.bind(this);
    // Attach close events
    this.closeBtns.forEach((closeBtn) => {
      closeBtn.addEventListener("click", () => this.closeDrawer());
    });

    // Attach toggle events to each drawer button
    this.drawerBtns.forEach((btn) => {
      btn.addEventListener("click", (e) => this.toggleDrawer(e,btn));
    });

    this.addEventListener("click", this.handleBackdropClick);
    window.addEventListener("resize", this.handleResize);
    this.subMenuEvents();
  } 

  disconnectedCallback() {
    this.removeEventListener("click", this.handleBackdropClick);
    window.removeEventListener("resize", this.handleResize);
  }

  handleBackdropClick(event) {
    if (event.target === this && this.classList.contains('is-visible')) {
      this.closeDrawer();
    }
  }

  handleResize() {
    if (this.classList.contains('is-visible')) {
      this.syncDrawerPlacement();
    }
  }

  captureControlsLockTop() {
    if (!this.headerWrapper) return null;

    const wrapperRect = this.headerWrapper.getBoundingClientRect();
    const rightControl = this.headerWrapper.querySelector('.titile_logo');
    const leftControl = this.headerWrapper.querySelector('.site--navigation');
    const refControl = rightControl || leftControl;
    const refRect = refControl?.getBoundingClientRect();

    if (!refRect) return wrapperRect.height / 2;
    return (refRect.top - wrapperRect.top) + (refRect.height / 2);
  }

  syncDrawerPlacement() {
    if (!this.headerWrapper) return;

    const rect = this.headerWrapper.getBoundingClientRect();
    const isDrawerAnimatingOrOpen =
      this.classList.contains('is-visible') ||
      this.classList.contains('is-closing') ||
      this.headerWrapper.classList.contains('menu-drawer-open') ||
      this.headerWrapper.classList.contains('menu-drawer-closing');

    if (!isDrawerAnimatingOrOpen || !Number.isFinite(this.controlsLockTop)) {
      this.controlsLockTop = this.captureControlsLockTop();
    }
    const lockTop = Number.isFinite(this.controlsLockTop) ? this.controlsLockTop : (rect.height / 2);

    document.body.style.setProperty('--header-drawer-left', `${rect.left}px`);
    document.body.style.setProperty('--header-drawer-width', `${rect.width}px`);
    document.body.style.setProperty('--header-drawer-top', `${rect.bottom}px`);
    document.body.style.setProperty('--header-controls-lock-top', `${lockTop}px`);
  }

  parseCssDuration(value) {
    if (!value) return 0;

    if (value.endsWith('ms')) {
      return Number.parseFloat(value);
    }

    if (value.endsWith('s')) {
      return Number.parseFloat(value) * 1000;
    }

    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : 0;
  }

  getCloseAnimationDuration() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return 0;
    }

    const rawDuration = window
      .getComputedStyle(this)
      .getPropertyValue('--header-drawer-close-duration')
      .trim();
    const duration = this.parseCssDuration(rawDuration);

    return duration > 0 ? duration : 820;
  }

  setAnimating(duration = 0, body = null) {
    this.isAnimating = true;
    clearTimeout(this.animationUnlockTimer);

    const fallback = Number.isFinite(duration) && duration > 0 ? duration : 500;
    let onEnd = null;

    const clearFlag = () => {
      if (!this.isAnimating) return;
      this.isAnimating = false;
      if (body && onEnd) {
        body.removeEventListener('transitionend', onEnd);
        body.removeEventListener('animationend', onEnd);
      }
      clearTimeout(this.animationUnlockTimer);
      this.animationUnlockTimer = null;
    };

    onEnd = (event) => {
      if (body && event.target !== body) return;
      clearFlag();
    };

    if (body) {
      body.addEventListener('transitionend', onEnd, { once: true });
      body.addEventListener('animationend', onEnd, { once: true });
    }

    this.animationUnlockTimer = setTimeout(clearFlag, fallback);
  }

  toggleDrawer(event,clickedBtn) {
    if (this.isAnimating) return;
    const isActive = this.classList.contains('is-visible');

    if (isActive) {
      this.closeDrawer();
    } else {
      this.openDrawer(event,clickedBtn);
       
    }
  }

  openDrawer(event,clickedBtn) {
    clearTimeout(this.closeTimer);
    clearTimeout(this.focusTimer);
    const drawerBody = this.querySelector('.header-menu-drawer-body');
    this.setAnimating(this.getOpenAnimationDuration(), drawerBody);
    this.controlsLockTop = this.captureControlsLockTop();
    this.classList.remove('is-closing');
    this.headerWrapper?.classList.remove('menu-drawer-closing');
    this.syncDrawerPlacement();
    this.classList.add('is-visible');
    this.headerWrapper?.classList.add('menu-drawer-open');
    requestAnimationFrame(() => this.syncDrawerPlacement());
    this.drawerBtns.forEach(btn => {
      btn.classList.add('is-active');
      btn.querySelector('.drawer-toggle-button')?.classList.add('is-active');
    });
    this.lastFocusedElement = clickedBtn;
    setTimeout(() => {
        focusElement = event.target;
        trapFocusElements(this);
      }, 300);
    
  }

  closeDrawer() {
    if (this.isAnimating) return;
    const menuelement = document.querySelector("header-drawer button");
    const animationDuration = this.getCloseAnimationDuration();
    const cleanupDelay = Math.max(animationDuration, 0);
    const drawerBody = this.querySelector('.header-menu-drawer-body');
    this.setAnimating(animationDuration, drawerBody);

    clearTimeout(this.closeTimer);
    clearTimeout(this.focusTimer);

    this.classList.add('is-closing');
    this.classList.remove('is-visible');
    this.headerWrapper?.classList.add('menu-drawer-closing');
    // Keep header layout locked in the "drawer open" state while the close animation runs
    this.headerWrapper?.classList.remove('menu-drawer-open');

    this.closeTimer = setTimeout(() => {
      document.body.classList.remove('overflow-hidden');

      // Reset nested menu state after the drawer is fully hidden to avoid mid-close layout jumps.
      this.querySelectorAll('[data-submenu-wrapper].is-active').forEach(subMenu => {
        subMenu.classList.remove('is-active');
      });

      this.querySelectorAll('[data-grand-submenu-wrapper].is-active').forEach(grandMenu => {
        grandMenu.classList.remove('is-active');
      });

      this.headerWrapper?.classList.remove('menu-drawer-closing');
      this.drawerBtns.forEach(btn => {
        btn.classList.remove('is-active');
        btn.querySelector('.drawer-toggle-button')?.classList.remove('is-active');
      });
      this.classList.remove('is-closing');
      this.controlsLockTop = null;
      menuelement?.focus();
      this.lastFocusedElement = '';
    }, cleanupDelay);
  }

  getOpenAnimationDuration() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return 0;
    const drawerBody = this.querySelector('.header-menu-drawer-body');
    if (!drawerBody) return 500;

    const durationString = window.getComputedStyle(drawerBody).transitionDuration || '';
    // transition-duration can be comma-separated; pick the longest
    const durations = durationString.split(',').map(str => str.trim()).map(this.parseCssDuration);
    const maxDuration = Math.max(...durations.filter(Number.isFinite));
    return Number.isFinite(maxDuration) && maxDuration > 0 ? maxDuration + 60 : 500; // small buffer
  }

subMenuEvents() {
  // Toggle Submenu
  this.querySelectorAll('[data-submenu-open]').forEach(subMenu => {
    subMenu.addEventListener('click', () => {
      const wrapper = subMenu.closest('[data-menu-link]');
      const subMenuWrapper = wrapper?.querySelector('[data-submenu-wrapper]');

      // Close other submenu wrappers and remove active from other wrappers and triggers
      this.querySelectorAll('[data-submenu-wrapper].is-active').forEach(el => {
        if (el !== subMenuWrapper) el.classList.remove('is-active');
      });

      this.querySelectorAll('[data-submenu-open].is-active').forEach(el => {
        if (el !== subMenu) el.classList.remove('is-active');
      });

      this.querySelectorAll('[data-menu-link].is-active').forEach(el => {
        if (el !== wrapper) el.classList.remove('is-active');
      });

      // Toggle current submenu and add active class to trigger and parent
      subMenuWrapper?.classList.toggle('is-active');
      subMenu.classList.toggle('is-active');
      wrapper?.classList.toggle('is-active');
    });
  });

  // Toggle Grand Submenu
  this.querySelectorAll('[data-grand-submenu-toggle]').forEach(grandToggle => {
    grandToggle.addEventListener('click', () => {
      const wrapper = grandToggle.closest('[data-submenu-link]');
      const grandWrapper = wrapper?.querySelector('[data-grand-submenu-wrapper]');

      // Close other grand submenu wrappers and remove active from others
      this.querySelectorAll('[data-grand-submenu-wrapper].is-active').forEach(el => {
        if (el !== grandWrapper) el.classList.remove('is-active');
      });

      this.querySelectorAll('[data-grand-submenu-toggle].is-active').forEach(el => {
        if (el !== grandToggle) el.classList.remove('is-active');
      });

      this.querySelectorAll('[data-submenu-link].is-active').forEach(el => {
        if (el !== wrapper) el.classList.remove('is-active');
      });

      // Toggle current grand submenu and add active class to trigger and parent
      grandWrapper?.classList.toggle('is-active');
      grandToggle.classList.toggle('is-active');
      wrapper?.classList.toggle('is-active');
    });
  });
}

}

customElements.define('header-menu-drawer', HeaderDrawerMenu);


class MobileHamburgerMenu extends HTMLElement {
  constructor() {
    super();
    this.body = document.body;
    this.header = document.querySelector("header");
    this.mobileHamburgerElements = document.querySelectorAll("[data-hamburger-mobile]");
    this.mobileMenus = document.querySelectorAll(".mobile-menus-item");
    this.backToNavElements = document.querySelectorAll("[data-backtonav-items], [data-subbacktonav-items]");
    this.closeElements = document.querySelectorAll("[data-mobile-menu-close]");
    this.lastFocusedElement = ""
    this.mobileAnimating = false;
    this.mobileAnimationTimer = null;
  }

  connectedCallback() {
    this.initHamburgerMenu();
    this.initMobileMenuItems();
    this.initMenuCloseTriggers();
    this.handleResize();
  
  }

  parseCssDurationMobile(value) {
    if (!value) return 0;
    if (value.endsWith('ms')) return Number.parseFloat(value);
    if (value.endsWith('s')) return Number.parseFloat(value) * 1000;
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : 0;
  }

  getMobileAnimationDuration(target) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return 0;
    if (!target) return 500;
    const durationString = window.getComputedStyle(target).transitionDuration || '';
    const durations = durationString
      .split(',')
      .map(str => str.trim())
      .map(this.parseCssDurationMobile);
    const maxDuration = Math.max(...durations.filter(Number.isFinite));
    return Number.isFinite(maxDuration) && maxDuration > 0 ? maxDuration : 500;
  }

  setMobileAnimating(duration = 500, target = null) {
    this.mobileAnimating = true;
    clearTimeout(this.mobileAnimationTimer);

    const fallback = Number.isFinite(duration) && duration > 0 ? duration : 500;
    const clearFlag = () => {
      this.mobileAnimating = false;
      if (target && onEnd) {
        target.removeEventListener('transitionend', onEnd);
        target.removeEventListener('animationend', onEnd);
      }
      clearTimeout(this.mobileAnimationTimer);
      this.mobileAnimationTimer = null;
    };

    const onEnd = (event) => {
      if (target && event.target !== target) return;
      clearFlag();
    };

    if (target) {
      target.addEventListener('transitionend', onEnd, { once: true });
      target.addEventListener('animationend', onEnd, { once: true });
    }

    this.mobileAnimationTimer = setTimeout(clearFlag, fallback + 80);
  }

  initHamburgerMenu() {
    this.mobileHamburgerElements.forEach((element) => {
      element.addEventListener("click", (event) => {
        event.preventDefault();
        if (this.mobileAnimating) return;
        const drawerSelector = element.getAttribute("href");
        const contentDrawerContainer = document.querySelector(drawerSelector);

        this.setMobileAnimating(this.getMobileAnimationDuration(contentDrawerContainer), contentDrawerContainer);

        if (element.classList.contains("active")) {
          this.closeMenu(element, contentDrawerContainer);
        } else {
          element.classList.add("active");
          this.body.classList.add("overflow-hidden", "mobile-menu-active");
          contentDrawerContainer.classList.add("is-active");
        }
        
        setTimeout(() => {
           focusElement = event.target;
            trapFocusElements(contentDrawerContainer);
          }, 300);
      });
    });
  }

  initMenuCloseTriggers() {
    this.closeElements.forEach((closeBtn) => {
      closeBtn.addEventListener("click", (event) => {
        event.preventDefault();
        if (this.mobileAnimating) return;
        const drawerSelector = closeBtn.getAttribute("data-mobile-menu-close");
        const contentDrawerContainer = document.querySelector(drawerSelector);
        this.setMobileAnimating(this.getMobileAnimationDuration(contentDrawerContainer), contentDrawerContainer);
        this.mobileHamburgerElements.forEach(el => el.classList.remove("active"));
        this.body.classList.remove("mobile-menu-active", "overflow-hidden");
        if (contentDrawerContainer) {
          contentDrawerContainer.classList.remove("is-active");
        }
        setTimeout(() => {
          focusElement.focus();
        this.lastFocusedElement = '';
      }, 300);
      });
    });
  }

  initMobileMenuItems() {
    this.mobileMenus.forEach((menuItem) => {
      menuItem.addEventListener("click", () => {
        const container = menuItem.closest("[data-child-items]");
        if (container) {
          container.classList.add("active");
        }
      });
    });

    this.backToNavElements.forEach((backItem) => {
      backItem.addEventListener("click", (event) => {
        const details = event.target.closest("details[open]");
        const activeChild = event.target.closest("[data-child-items].active");

        if (details) details.removeAttribute("open");
        if (activeChild) activeChild.classList.remove("active");
      });
    });
  }

  handleResize() {
    window.addEventListener("resize", () => {
      if (window.innerWidth > 991 && this.body.classList.contains("mobile-menu-active")) {
        this.body.classList.remove("mobile-menu-active", "overflow-hidden");
        document.querySelectorAll("[data-hamburger-mobile]").forEach(el => el.classList.remove("active"));
        document.querySelectorAll("[data-mobile-drawer-content]").forEach(drawer => drawer.classList.remove("is-active"));
      }
    });
  }

  closeMenu(triggerElement, drawerElement) {
    this.body.classList.remove("overflow-hidden", "mobile-menu-active");
    triggerElement.classList.remove("active");
    if (drawerElement) {
      drawerElement.classList.remove("is-active");
    }
    
     
  }
}

customElements.define("mobile-hamburger-menu", MobileHamburgerMenu);
